module.exports = __webpack_public_path__ + "img/record-screen-help-view.ad6f0324.svg";